import "./utils/heroImage";
import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-258" data-mp="1wbw62j7yupg6" />, document.getElementById("root"));